import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {orderBy} from 'lodash-es';
import {Primitive} from '@shared/interfaces/primitive';
import {format, parseISO, toDate} from 'date-fns';
import {DateTime} from 'luxon';
import {Zone} from 'luxon/src/zone';

export function optional(value: string | number) {
    return value ? value : '';
}

export function ymd(date: Date) {
    return date ? format(date, 'yyyy-MM-dd') : '';
}

export function jsDate(date: Date | number | string): Date {
    if (date instanceof Date) {
        return date;
    } else if (typeof date === 'number') {
        return toDate(date);
    } else if (typeof date === 'string') {
        return parseISO(date, {});
    } else {
        throw new Error('Invalid date format');
    }
}

export class Repository<S, C = S> {
    protected baseURL = environment.apiUrl;
    protected baseURL3 = environment.api3Url;

    protected entityUrl: string;

    constructor(protected http: HttpClient, protected entity: string) {
        if (entity) {
            this.entityUrl = `${this.baseURL}/api/${this.entity}`;
        }
    }

    create(model: C): Observable<C> {
        return this.http.post<any>(this.entityUrl, model).pipe(this.mapSingle());
    }

    update(model: C): Observable<C> {
        return this.http.post<any>(`${this.entityUrl}/${model['id']}`, model).pipe(this.mapSingle());
    }

    updatePartial(model: Partial<C>): Observable<C> {
        return this.http.put<any>(`${this.entityUrl}/partial/${model['id']}`, model).pipe(this.mapSingle());
    }

    get(id: string): Observable<C> {
        return this.http.get<any>(`${this.entityUrl}/${id}`).pipe(this.mapSingle());
    }

    delete(id: string): Observable<C> {
        return this.http.delete<any>(`${this.entityUrl}/${id}`).pipe(this.mapSingle());
    }

    getAll(): Observable<C[]> {
        return this.http.get<S[]>(`${this.entityUrl}/list`).pipe(
            this.mapList()
        );
    }

    protected mapList() {
        return map((res: any) => {
            if (res.model) {

                return res.model.map(m => this.covertFromServer(m));
            } else {
                return res.map(m => this.covertFromServer(m));
            }
        });
    }

    protected sortBy(field: string) {
        return map((list: any[]) => orderBy(list, field));
    }

    protected mapSingle() {
        return map((rs: any) => this.covertFromServer(rs.model ?? rs));
    }

    protected mapPrimitive() {
        return map((v: Primitive<any>) => v.model ?? v.model.value ?? 0);
    }

    protected covertFromServer(entity: S): C {
        return entity as unknown as C;
    }

    protected covertToServer(entity: C): S {
        return entity as unknown as S;
    }
}


